import React from "react";
import { RefreshCw } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

function fmt(n, d = 2) {
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function BudgetSummaryCard({ state, c, pct, info, onModify, onReset }) {
  return (
    <div
      className="mb-4 p-5 transition-all duration-500"
      style={{ background: c.bg, border: `1px solid ${c.border}`, borderRadius: "3px" }}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs uppercase tracking-widest font-semibold" style={{ ...LORA, color: c.text }}>
          {c.label}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={onModify}
            className="text-xs px-2.5 py-1 border transition-colors"
            style={{ ...LORA, color: c.text, borderColor: c.border, borderRadius: "2px", background: "transparent" }}
            data-testid="btn-modify-budget"
          >
            Modifier
          </button>
          <button
            onClick={onReset}
            className="p-1 text-[#9A8F86] hover:text-[#C17F59] transition-colors"
            title="Réinitialiser"
            data-testid="btn-reset-budget"
          >
            <RefreshCw size={13} strokeWidth={1.5} />
          </button>
        </div>
      </div>

      {state.total ? (
        <>
          <p
            className="text-5xl sm:text-6xl font-bold leading-none mb-1"
            style={{ ...SERIF, color: c.text, fontWeight: 700 }}
            data-testid="budget-remaining"
          >
            {fmt(state.remaining)} €
          </p>
          <p className="text-sm mb-3" style={{ ...LORA, color: c.text, opacity: 0.75 }}>
            sur {fmt(state.total)} € total ·{" "}
            {state.currency !== "EUR"
              ? `Devise : ${state.currency} (1 € = ${info.rate} ${info.symbol})`
              : "Devise : EUR"}
          </p>
          <div className="h-2.5 rounded-full overflow-hidden" style={{ background: c.border }}>
            <div
              className="h-full transition-all duration-700 rounded-full"
              style={{ width: `${Math.min(100, pct)}%`, background: c.bar }}
              data-testid="budget-bar"
            />
          </div>
          <p className="text-xs text-right mt-1.5" style={{ ...LORA, color: c.text, opacity: 0.65 }}>
            {fmt(pct, 0)} % restant
          </p>
        </>
      ) : (
        <div className="text-center py-2">
          <p className="text-sm text-[#9A8F86] italic mb-3" style={LORA}>Aucun budget défini</p>
          <button
            onClick={onModify}
            className="px-6 py-2.5 bg-[#C17F59] text-[#F9F6F0] text-sm hover:bg-[#A86A46] transition-colors"
            style={{ ...LORA, borderRadius: "2px" }}
            data-testid="btn-set-budget"
          >
            Définir mon budget
          </button>
        </div>
      )}
    </div>
  );
}
